import React from 'react'
import IconButton from 'material-ui/IconButton'
import Icon from 'material-ui/Icon'
// import { saveToExcel } from '../helpers'

// <IconButton onClick={() => saveToExcel(props.data, props.fileName)}>
const DownloadButton = props => {
  return (
    <IconButton onClick={() => alert(props.fileName)}>
      <Icon>file_upload</Icon>
    </IconButton>
  )
}

export default DownloadButton



// WEBPACK FOOTER //
// ./src/core/components/UploadButton.js